import { useLocation, Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { cases } from '@/mocks/cases';
import useSeo from '@/hooks/useSeo';

export default function NotFound() {
  const location = useLocation();
  const suggestions = cases.slice(0, 3);

  useSeo({
    title: '页面不存在 - 404 | 网红爆料网',
    description: '你访问的页面不存在或链接已调整，可以返回首页或从爆料列表继续浏览已公开的材料。',
    keywords: '网红爆料,爆料列表,页面不存在',
    path: '/404',
  });

  return (
    <SiteLayout>
      <section className="mx-auto flex max-w-[1280px] flex-col items-center px-4 py-20 text-center md:px-6 md:py-24">
        <span className="font-heading text-6xl font-black text-background-300 md:text-8xl">404</span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">这个页面不存在</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          链接可能已经调整，或者对应的爆料已被合并。
          <span className="mt-1 block font-mono text-xs text-foreground-400">{location.pathname}</span>
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            返回首页
          </Link>
          <Link
            to="/cases"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            浏览爆料列表
          </Link>
        </div>

        <div className="mt-14 w-full text-left">
          <h2 className="font-heading text-lg font-semibold text-foreground-950">或许你想看看这些</h2>
          <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
            {suggestions.map((item) => (
              <Link
                key={item.id}
                to={`/case/${item.slug}`}
                className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950">{item.title}</h3>
                <p className="mt-2 line-clamp-2 text-xs text-foreground-600">{item.summary}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}